export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Reputacion',
	plural_model_name_spanish: 'Reputaciones',
	create_model_name_spanish: 'Nueva Reputacion',
	text_delete: 'la',
}